import { Button } from '@/components/UI/Common/Admin/Button';
import { Input } from '@/components/UI/Common/Admin/Input';
import { Select } from '@/components/UI/Common/Admin/Select';
import { applicationLinkScheme } from '@/config/validations';
import { useGetList } from '@/queries/admin';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import z from 'zod';

export type FormData = z.infer<typeof applicationLinkScheme>;

export const Form = ({
  formData,
  onSubmit,
  onDelete,
}: {
  onSubmit: (data: FormData) => void;
  formData?: Partial<FormData>;
  onDelete?: VoidFunction;
}) => {
  const { data: applications } = useGetList('applications');

  const initialFormState = formData
    ? formData
    : {
        title: '',
        link: '',
        description: '',
        sort: 1,
        applicationGroupId: '',
      };

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
    control,
  } = useForm<FormData>({
    resolver: zodResolver(applicationLinkScheme),
    defaultValues: initialFormState,
    mode: 'onChange',
  });

  const applicationGroupsOptions = useMemo(
    () => applications?.data.map((app) => ({ label: app.title, value: app.id })),
    [applications],
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid gap-4">
      <Input error={errors.title?.message} label="Название" required {...register('title')} />
      <Input {...register('link')} error={errors?.link?.message} label="Ссылка" required />
      <Input {...register('description')} label="Описание" />

      <Input
        error={errors.sort?.message}
        label="Сортировка"
        required
        type="number"
        min={1}
        {...register('sort', { valueAsNumber: true })}
      />

      <Controller
        name="applicationId"
        control={control}
        render={({ field, fieldState }) => (
          <Select
            required
            error={fieldState.error?.message}
            label="Приложение"
            options={applicationGroupsOptions ?? []}
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
          />
        )}
      />

      <div className="flex justify-end gap-4">
        {onDelete && (
          <Button variant="danger" onClick={onDelete} type="button">
            Удалить
          </Button>
        )}
        <Button variant="secondary" disabled={!isDirty} onClick={() => reset()} type="button">
          Сбросить
        </Button>
        <Button disabled={!isValid || !isDirty} type="submit">
          Сохранить
        </Button>
      </div>
    </form>
  );
};
